module.exports = __webpack_public_path__ + "img/brn.1d4e6091.svg";